import type { AdminMediaResponse } from "@ckgo2/shared/types";
import type { PickerTileState } from "./picker/pickerModel";

/**
 * Klávesy velkého prohlížeče fotek (hodnoty `KeyboardEvent.key`). Legenda prohlížeče je
 * vypisuje odsud, takže legenda a obsluha kláves se nerozejdou.
 */
export const PHOTO_VIEWER_KEYS = {
  next: ["ArrowRight"],
  prev: ["ArrowLeft"],
  star: ["f", "F"],
  delete: ["Delete", "Backspace"],
  detail: ["Enter"],
  close: ["Escape"],
} as const;

export type PhotoViewerKeyAction = keyof typeof PHOTO_VIEWER_KEYS;

/**
 * Rozhraní prohlížeče fotek (řez 03, Kontrakt bod 6).
 *
 * - `onDeleted(id)`: rodič odebere položku z `items`, sníží `total` o 1 v témže renderu
 *   a srovná offsetový kurzor seznamu (další stránka žádnou fotku nepřeskočí); index po
 *   smazání řídí prohlížeč přes `onIndexChange`, rodič ho smí jen oříznout do rozsahu `items`.
 * - `onOpenDetail(id)`: rodič otevře detail nad prohlížečem, prohlížeč zůstane připojený;
 *   dokud je v DOM `[data-media-drawer]`, prohlížeč klávesy nezpracovává.
 */
export interface PhotoViewerProps {
  /** Načtené fotky v pořadí seznamu. */
  items: readonly AdminMediaResponse[];
  index: number;
  total: number;
  hasMore: boolean;
  onIndexChange: (index: number) => void;
  /** Donačte další stránku seznamu. */
  onLoadMore: () => Promise<void>;
  onClose: () => void;
  /** Stránka Média; okno výběru fotek ho nepředává (řez 05, AK9). */
  onOpenDetail?: (id: string) => void;
  /** Po ★. */
  onChanged: (item: AdminMediaResponse) => void;
  /** Po smazání do koše; okno výběru fotek ho nepředává (řez 05, AK9). */
  onDeleted?: (id: string) => void;
  /** `"picker"` = prohlížeč v okně výběru fotek (řez 05): „Vybrat“ místo detailu a mazání. */
  mode?: "library" | "picker";
  /** Jen v režimu `"picker"`: stav fotky ve výběru (čte se při každém renderu) a její výběr. */
  pick?: { stateOf: (id: string) => PickerTileState; onPick: (id: string) => void };
}
